import { useClosingPackage, type ClosingPackageManifest } from '@/hooks/useClosingPackage'
import { useLocalizationConfig } from '@/hooks/useDateFormatter'
import { localToday } from '@/lib/date'

/**
 * EP-155 decision D6: the month the accountant is closing. The previous month
 * until nothing is open in its closing package (slips to review, unmatched
 * bank rows, expenses without a receipt, payments with no payer), then the
 * current one. Disabled, it fetches nothing.
 */
export interface ClosingMonth {
  month: string
  manifest: ClosingPackageManifest | undefined
  isLoading: boolean
}

export function openClosingItems(m: ClosingPackageManifest): number {
  return [
    m.payments_pending_verification_count,
    m.bank_rows_unmatched_count,
    m.expenses_missing_receipt_count,
    m.payments_unidentified_count,
  ].filter((n) => (n ?? 0) > 0).length
}

function previousMonth(month: string): string {
  const [y, m] = month.split('-').map(Number)
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`
}

export function useClosingMonth(enabled: boolean): ClosingMonth {
  const { timezone } = useLocalizationConfig()
  const current = localToday(timezone).slice(0, 7)
  const previous = previousMonth(current)
  const prev = useClosingPackage(enabled ? previous : '')
  const previousClear = prev.data !== undefined && openClosingItems(prev.data) === 0
  const cur = useClosingPackage(enabled && previousClear ? current : '')
  if (previousClear) return { month: current, manifest: cur.data, isLoading: cur.isLoading }
  return { month: previous, manifest: prev.data, isLoading: enabled && prev.isLoading }
}

